// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NotificationCards.css */
.notificationHeader {
  margin-top: 2rem;
}

.notificationCard {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 12px;
  background-color: var(--background-consistent);
  border-radius: 8px;
  transition: box-shadow 0.2s ease;
}

.notificationImage {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid var(--theme-consistent);
}

.notificationContent {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notificationInfo {
  display: flex;
  flex-direction: column;
}

.userName {
  font-size: 17px;
  font-weight: 600;
  margin: 0;
  color: var(--text-consistent);
}

.notificationActions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  justify-content: flex-end;
}

.acceptBtn,
.rejectBtn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-width: 100px;
}

.acceptBtn {
  background-color: var(--theme-consistent);
  color: white;
}

.acceptBtn:hover {
  background-color: var(--theme-consistent);
  opacity: 0.9;
}

.rejectBtn {
  background-color: #e4e6eb;
  color: #000;
}

.rejectBtn:hover {
  background-color: #dcdde1;
}

@media (max-width: 600px) {
  .notificationCard {
    padding: 8px;
  }

  .notificationImage {
    width: 50px;
    height: 50px;
  }

  .userName {
    font-size: 15px;
  }

  .acceptBtn,
  .rejectBtn {
    padding: 6px 12px;
    font-size: 14px;
    min-width: 80px;
  }
}

/* Notifications.css */
.scrollContainer {
  background-color: var(--background);
  height: calc(100vh - 64px);
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
  overflow-y: auto;
}

.notificationHeader .notificationTitle {
  color: var(--text-primary);
  padding-top: 16px;
  text-align: center;
}

.searchContainer {
  padding: 0 16px;
  margin-bottom: calc(64px + env(safe-area-inset-bottom));
}

.requestsNotificationCardContainer {
  margin: 8px 0;
  background: none;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;
  border-radius: 8px;
  transition: box-shadow 0.3s ease;
}

.request-loader-container {
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.request-loader-container.show {
  display: flex;
}

.noPending-message {
  color: var(--text-primary);
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.initial-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 150px);
}

@media (max-width: 600px) {
  .requestsNotificationCardContainer {
    margin: 8px 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/Notifications.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8CAA8C;EAC9C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* NotificationCards.css */\n.notificationHeader {\n  margin-top: 2rem;\n}\n\n.notificationCard {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  gap: 12px;\n  background-color: var(--background-consistent);\n  border-radius: 8px;\n  transition: box-shadow 0.2s ease;\n}\n\n.notificationImage {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 1px solid var(--theme-consistent);\n}\n\n.notificationContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.notificationInfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.userName {\n  font-size: 17px;\n  font-weight: 600;\n  margin: 0;\n  color: var(--text-consistent);\n}\n\n.notificationActions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n  justify-content: flex-end;\n}\n\n.acceptBtn,\n.rejectBtn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  min-width: 100px;\n}\n\n.acceptBtn {\n  background-color: var(--theme-consistent);\n  color: white;\n}\n\n.acceptBtn:hover {\n  background-color: var(--theme-consistent);\n  opacity: 0.9;\n}\n\n.rejectBtn {\n  background-color: #e4e6eb;\n  color: #000;\n}\n\n.rejectBtn:hover {\n  background-color: #dcdde1;\n}\n\n@media (max-width: 600px) {\n  .notificationCard {\n    padding: 8px;\n  }\n\n  .notificationImage {\n    width: 50px;\n    height: 50px;\n  }\n\n  .userName {\n    font-size: 15px;\n  }\n\n  .acceptBtn,\n  .rejectBtn {\n    padding: 6px 12px;\n    font-size: 14px;\n    min-width: 80px;\n  }\n}\n\n/* Notifications.css */\n.scrollContainer {\n  background-color: var(--background);\n  height: calc(100vh - 64px);\n  padding-bottom: calc(64px + env(safe-area-inset-bottom));\n  overflow-y: auto;\n}\n\n.notificationHeader .notificationTitle {\n  color: var(--text-primary);\n  padding-top: 16px;\n  text-align: center;\n}\n\n.searchContainer {\n  padding: 0 16px;\n  margin-bottom: calc(64px + env(safe-area-inset-bottom));\n}\n\n.requestsNotificationCardContainer {\n  margin: 8px 0;\n  background: none;\n  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;\n  border-radius: 8px;\n  transition: box-shadow 0.3s ease;\n}\n\n.request-loader-container {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.request-loader-container.show {\n  display: flex;\n}\n\n.noPending-message {\n  color: var(--text-primary);\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.initial-loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 150px);\n}\n\n@media (max-width: 600px) {\n  .requestsNotificationCardContainer {\n    margin: 8px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
